require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-archive-limespot-com.json") })
        }
      }, "path---projects-archive-limespot-com");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-archive-limespot-com!./.cache/json/projects-archive-limespot-com.json
// module id = 358
// module chunks = 231608221292675